import React from 'react';
import Select from 'react-select';

const SearchableDropdown = ({ label, options, placeholder, value, onChange  }) => {
  const handleChange = (selectedOption) => {
    onChange(selectedOption);
  };
  return (
    <div style={{display:'flex',flexDirection:'column'}}>
      <p style={{margin:0 }}> {label}</p>
      <Select
        // className="basic-single"
        // classNamePrefix="select"
        // defaultValue={options[0]}
        // isClearable={true} 
        // isSearchable={true} 
        // name={label}
        // options={options}
        className="basic-single"
        classNamePrefix="select"
        value={value}
        onChange={handleChange}
        options={options}
        placeholder={placeholder}
        isClearable={true}
        isSearchable={true}
      />
    </div>
  );
};

export default SearchableDropdown;
